import React from "react";
import { useHistory } from "react-router-dom";
import "./Home.css";
import deviceImage from '../../assets/images/home1.png'
import appImage from '../../assets/images/homescreen.png'
import Footer from '../../components/Footer/Footer';
import PlainHeader from "../../components/PlainHeader/PlainHeader";

const Home = () => {

    let history = useHistory();

    return (
        <div className="l-main">
            <PlainHeader />
            <section className="home" id="home">
                <div className="homeContainer bd-grid">
                    <div className="homeImg">
                        <img alt="NoWires laptop and phone" src={deviceImage} />
                    </div>

                    <div className="homeData">
                        <h1 className="homeTitle">Explore files<br />like a pro</h1>
                        <p className="homeDescription">
                            Download No Wires on your android phone <br/> and laptop now.
                        </p>
                        <div onClick={() => history.push('/download')} className="homeButton">Download</div>
                    </div>
                </div>
            </section>
            <section className="feature" id="feature-1">
                <div className="fContainer bd-grid" >

                    <div className="feature-text-1">
                        <h4 className="feature-title">Transfer and Browse files seamlessly </h4>
                        <p className="subtitle">Download your files from android phone to your laptop with a simple click. Check your downloaded files in desktop in a folder named "No Wires".</p>
                    </div>

                    <div className="featureImg-1">
                        <img alt="NoWires feature 1" src={appImage} />
                    </div>
                </div>
            </section>
            <section className="feature" id="feature-2">
                <div className="fContainer bd-grid feature-reverse">

                    <div className="featureImg-1">
                        <img alt="NoWires feature 1" src={appImage} />
                    </div>

                    <div className="feature-text-1">
                       <h4 className="feature-title">Doesn't use internet for data transfers</h4>
                        <p className="subtitle">No Wires only uses internet connection to pair your laptop and phone, it doesn't use your internet connection while transferring/browsing data.</p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Home;